/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ConfirmedActivityLight
 */
export interface ConfirmedActivityLight {
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'type': ConfirmedActivityLightTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'usageFeeId': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'cardBillId': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'cardPointId': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'serviceChargeId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof ConfirmedActivityLight
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof ConfirmedActivityLight
     */
    'pointAmount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfirmedActivityLight
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof ConfirmedActivityLight
     */
    'pointBalance'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConfirmedActivityLight
     */
    'isConfirmed': boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'appliedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfirmedActivityLight
     */
    'executedAt': string | null;
}

export const ConfirmedActivityLightTypeEnum = {
    payBill: 'PAY_BILL',
    deposit: 'DEPOSIT',
    withdrawal: 'WITHDRAWAL',
    reward: 'REWARD',
    usageFee: 'USAGE_FEE',
    point: 'POINT',
    cardPoint: 'CARD_POINT',
    campaignPoint: 'CAMPAIGN_POINT',
    card: 'CARD',
    depositFromGuaranteeMoney: 'DEPOSIT_FROM_GUARANTEE_MONEY',
    withdrawalToGuaranteeMoney: 'WITHDRAWAL_TO_GUARANTEE_MONEY',
    serviceCharge: 'SERVICE_CHARGE'
} as const;

export type ConfirmedActivityLightTypeEnum = typeof ConfirmedActivityLightTypeEnum[keyof typeof ConfirmedActivityLightTypeEnum];


